export default "__VITE_ASSET__6c8d57d1__"